<div style="position:relative;">
    <app-loader [showLoader]=showLoad></app-loader>
    <div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs {{sectionclass}}"
         style="position: relative; min-height: 27em;">
        <div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap"
                style="position: relative;" *ngIf="campaignCarouselItem">

                <div class="o-stack__cell lift-title-div">
                    <h5 class="lift-title">Lift Trend: {{campaignCarouselItem.name}}</h5>
            </div>
            <!-- carousel icons start -->
            <div class="o-stack__cell carousel-width_p2" style="">
                <div class="o-stack o-stack--center o-stack--nowrap o-stack--tinyGap u-font-small">
                    <div class="o-stack__cell u-relative" style="position:absolute; right: 20px; top: 5px;" *ngIf="campaignsList.length > 1">
                        <a class="c-icon c-icon--main u-color-minor" style="cursor: pointer;">
                          <span class="next" (click)="prevArrow()" class="carousel-arrow-style" style="font-size: 3em; color: #FFFFFF;">
                              <i class="fa fa-angle-left" aria-hidden="true"></i>
                          </span>
                        </a>
                        <a class="c-icon c-icon--main u-color-minor" style="margin-left:5px; cursor:pointer;">
                          <span class="prev" (click)="nextArrow()" class="carousel-arrow-style" style="font-size: 3em; color: #FFFFFF;">
                            <i class="fa fa-angle-right" aria-hidden="true"></i>
                          </span>
                        </a>
                    </div>
                </div>
            </div>
            <!-- carousel icons end -->
        </div>
        <div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom lift-trend-no-data-header"
                style="position: relative; font-size: 1.1em;" *ngIf="!campaignCarouselItem">Lift Trends
        </div>
        <div>
            <div class="c-portlet__content u-pt-small" style="width:100%;" *ngIf="campaignCarouselItem">
                <div class="o-stack o-stack--center  o-stact_ImgSpecs" style="height: auto;">
                    <div class="tables-container product-lift-table-container" style="margin: 0 auto;">
                        <div class="table-layout">
                            <div [id]="'campaign'+i" class="individual-table" style="min-height: 200px;">
                                <app-table-horizontal class="individual-table"
                                                      [tableData]="campaignCarouselItem"></app-table-horizontal>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="c-portlet__content u-pt-small lift-trend-no-data-body"
                 style="position:absolute; top: 0px; left: 0px; width: 100%; height: 100%;"
                 *ngIf="!campaignCarouselItem">
                <img [src]="placeholderimage" class="lift-trend-no-data-placeholder" style="width: 80%"/>
            </div>
        </div>
    </div>
</div>
